import { Link } from "react-router-dom";

export default function AccessHeader() {
    return (
        <header className="relative z-10 border-b border-[rgba(201,168,106,0.15)] bg-[#0B0B0C]/40 backdrop-blur-sm">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-6 flex items-center justify-between">
                <a
                    href="/"
                    className="font-serif text-[#C9A86A] text-xl tracking-[0.2em] hover:text-[#D9BC80] transition-colors duration-300"
                    aria-label="Advanced Connected Technologies — return to homepage"
                    data-testid="site-logo-home"
                >
                    ACT
                </a>
                <span className="text-[10.5px] tracking-[0.32em] uppercase text-[#9A958A]">
                    Private Portfolio
                </span>
            </div>
        </header>
    );
}
